import { render, staticRenderFns } from "./PermissionsEditor.vue?vue&type=template&id=312a6ccf&scoped=true&"
import script from "./PermissionsEditor.vue?vue&type=script&lang=ts&"
export * from "./PermissionsEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PermissionsEditor.vue?vue&type=style&index=0&id=312a6ccf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312a6ccf",
  null
  
)

export default component.exports